// カードテンプレート編集画面-保存確認ダイアログ
import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextField, Button, Grid, Container, Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { CardTemplateDb, generateCardTemplateId, updateCardTemplate, addCardTemplate } from '../redux/cardTemplateDbSlice';
import { addCardTemplateAttribute, updateCardTemplateAttribute, deleteCardTemplateAttribute } from '../redux/cardTemplateAttributeDbSlice';
import { addCardTemplateShape, updateCardTemplateShape, deleteCardTemplateShape } from '../redux/cardTemplateShapeDbSlice';
import { addRelationUserCardTemplate } from '../redux/relationUserCardTemplateDbSlice';
import { addRelationPaletteCardTemplate } from '../redux/relationPaletteCardTemplateDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import { deepCopy } from '../general';
import { EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType } from './EditTemplateDialog';

const ItemField = styled(TextField)`
  width: 100%;
`
const SaveButton = styled(Button)`
  width: 100%;
  height: 50px;
`

type SaveTemplateDialogProps = {
  open: boolean;
  onClose: () => void;
  id: string;
  template: CardTemplateDb;
  setTemplate: (template: CardTemplateDb) => void;
  attributes: EditTemplateAttributeDbHashType;
  shapes: EditTemplateShapeDbHashType;
  paletteId: string;
  cardTemplatesLength: number;
  onSaveClose: () => void;
}
const SaveTemplateDialog: React.FC<SaveTemplateDialogProps> = ({open, onClose, id, template, setTemplate, attributes, shapes, paletteId, cardTemplatesLength, onSaveClose}) => {
  const dispatch = useDispatch();
  const attributeIds = Object.keys(attributes);
  const attributeValues = attributeIds.map(id => attributes[id]);
  const shapeIds = Object.keys(shapes);
  const shapeValues = shapeIds.map(id => shapes[id]);
  const userId = useCurrentUserId();

  const getTitle = () => {
    if (id === 'newTemplate') return('新規のカードテンプレートを追加します');
    else return('変更したカードテンプレートを保存します');
  }

  //既存のテンプレートを上書き更新
  const closeWithUpdateDb = () => {
    if(id !== 'newTemplate') {
      dispatch(updateCardTemplate({id: id, ...template}));
      attributeIds.forEach((id, ix) => {
        const item = attributeValues[ix];
        const prefix = id.slice(0, 12);
        // add new attribute item
        if (prefix === 'newAttribute' && item) dispatch(addCardTemplateAttribute(item));
        // update existing attribute item
        else if (item) dispatch(updateCardTemplateAttribute({id: id, ...item}));
        // delete existing attribute item
        else if (prefix !== 'newAttribute' && item === null) dispatch(deleteCardTemplateAttribute({id: id}));
      })
      shapeIds.forEach((id, ix) => {
        const shape = shapeValues[ix];
        const prefix = id.slice(0, 8);
        // add new shape item
        if (prefix === 'newShape' && shape) dispatch(addCardTemplateShape(shape));
        // update existing shape item
        else if (shape) dispatch(updateCardTemplateShape({id: id, ...shape}));
        // delete existing shape item
        else if (prefix !== 'newShape' && shape === null) dispatch(deleteCardTemplateShape({id: id}));
      })
    }

    onSaveClose();
  }

  //テンプレートを新規追加
  const closeWithAddDb = () => {
    const newId = generateCardTemplateId();
console.log('add template.shadow = ' + template.shadow)
    // add card template
    dispatch(addCardTemplate({id: newId, ...template}));
    // add attributes
    const newAttributes = deepCopy(attributeValues);
    attributeValues.forEach((attribute, ix) => {
      if (attribute) newAttributes.splice(ix, 1, {...attribute, cardTemplateId: newId});
    })
    newAttributes.forEach(attribute => {
      if (attribute) dispatch(addCardTemplateAttribute(attribute));
    });
    // add shapes
    const newShapes = deepCopy(shapeValues);
    shapeValues.forEach((shape, ix) => {
      if (shape) newShapes.splice(ix, 1, {...shape, cardTemplateId: newId});
    })
    newShapes.forEach(shape => {
      if (shape) dispatch(addCardTemplateShape(shape));
    })
    // add relation between user and card template
    dispatch(addRelationUserCardTemplate({userId: userId || 'no user', cardTemplateId: newId}));
    // add relation between palette and card template
    dispatch(addRelationPaletteCardTemplate({paletteId: paletteId, cardTemplateId: newId, order: cardTemplatesLength}));

    onSaveClose()
  }
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md" >
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>
        <Grid container spacing={0}>
          <Grid item xs={6} />
          <Grid item xs={6}>
            <ItemField  variant='outlined' 
                        defaultValue={template.name} 
                        label='新しいカードテンプレート名' 
                        onChange={(ev) => setTemplate({...template, name: ev.target.value})}
            />
          </Grid>
        </Grid>
        <Box mt={1}>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Grid container spacing={0}>
                <Grid item xs={9}>
                  {(id !== 'newTemplate') &&
                    <SaveButton variant='contained' color='primary'
                                onClick={closeWithUpdateDb}>
                      現在のテンプレートに 上書き保存する
                    </SaveButton>
                  }
                </Grid>
                <Grid item xs={3}>
                  {(id !== 'newTemplate') &&
                    <Box mt={2}><Container>または</Container></Box>
                  }
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <SaveButton variant='contained' color='primary'
                          onClick={closeWithAddDb}>
                { (id === 'newTemplate') ? 
                  'テンプレートを新規追加する' :
                  '別の名前をつけて 新しいテンプレートとして 新規追加する'
                }
              </SaveButton>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SaveTemplateDialog;
